module.exports = __webpack_public_path__ + "img/1993.278e5b4b.png";